import { Formik, FormikProps } from 'formik';
import React, { useEffect, useMemo } from 'react';
import { User, defaultUser } from '@Types/user.types';
import { useDispatch, useSelector } from 'react-redux';

import NewUserFields from '../NewUserFields/NewUserFields';
import { getProducts } from '@Actions/products';
import { getRole } from '@innovyze/stylovyze';
import { getUsers } from '@Actions/users';
import { getValue } from '@Selectors';

export const roles = ['User', 'Editor', 'Admin'];

interface NewUserFormProps {
	setNewUserFormikProps: React.Dispatch<
		React.SetStateAction<Partial<FormikProps<User>>>
	>;
}

export const NewUserForm = ({ setNewUserFormikProps }: NewUserFormProps) => {
	const dispatch = useDispatch();
	const { user } = useSelector(getValue).users.userById;
	const initialUser = useMemo(
		() =>
			user && {
				...user,
				email: user?.username,
				role: user?.role ? getRole(user?.role) : '',
			},
		[user],
	);

	useEffect(() => {
		dispatch(getUsers({ pageSize: 25, page: 1 }));
		dispatch(getProducts());
	}, []);

	return (
		<Formik
			onSubmit={() => undefined}
			initialValues={initialUser || defaultUser}>
			{formikProps => {
				// eslint-disable-next-line
				useEffect(() => {
					setNewUserFormikProps(formikProps);
				}, [formikProps?.values, formikProps?.errors]);
				return <NewUserFields />;
			}}
		</Formik>
	);
};
